import { useQuery } from "@tanstack/react-query";
import { getDeveloperUsers } from "../api";

export const DEVELOPER_USERS_QUERY_KEY = "developerUsers";

interface UseDeveloperUsersOptions {
  developerUId: string;
  search?: string;
  page?: number;
  pageSize?: number;
  enabled?: boolean;
}

export const useDeveloperUsers = ({
  developerUId,
  search,
  page = 1,
  pageSize = 50,
  enabled = true,
}: UseDeveloperUsersOptions) => {
  return useQuery({
    queryKey: [DEVELOPER_USERS_QUERY_KEY, developerUId, search, page, pageSize],
    queryFn: async () => {
      const response = await getDeveloperUsers({
        developerUId,
        search,
        page,
        pageSize,
      });
      return response.data;
    },
    enabled: enabled && !!developerUId,
    staleTime: 60000, // 1 minute
  });
};

export default useDeveloperUsers;

